import { SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER } from "../../constants";

export const hideNotificationsOptInBanner = () => dispatch => {
  dispatch({
    type: SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER,
    payload: { show: false, isSuccess: false }
  });
};
